import { gql } from "@apollo/client";

const WEBSITE_BOOKING_STATUS_QUERY = gql`
query getWebUserStatus {
    webUserStatus{
      isWebUser
      nextScreen
      messages
      success
    }
  }
`;

export default WEBSITE_BOOKING_STATUS_QUERY;
